var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{\r\n\t\tfill:#2B9BC7;\r\n\t}\r\n\r\ng{\r\n\ttransform: scale(2.5) translate(-30%, -30%);\r\n}\r\n\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.2,666.3c-15.3-0.4-31.2-5.1-46.1-12.7C503,620,453.4,570.2,422.9,502.1c-5.7-12.8-9-26.5-8.6-40.7 c0.4-15.8,6.5-28,22-34.1c7.7-3,15.3-6.4,23-9.4c8.7-3.4,16.1-0.8,20.8,7.3c7.2,12.3,14.4,24.7,21.4,37.1c5.7,10,3.4,18.4-6.5,24.4 c-11.9,7.2-17,18.6-13.3,30.9c1,3.3,2.8,6.6,4.9,9.4c19.1,25.3,41.3,47.6,66.6,66.7c13.7,10.4,31,7,40-7.6 c6.9-11.3,14.7-13.3,26.1-6.7c11.7,6.7,23.3,13.5,35,20.2c9.2,5.4,11.7,12.3,7.9,22.2c-2.6,6.8-5.5,13.5-8.2,20.3 C647,660.1,636,665.9,615.2,666.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone .ba6d3983633fd11651eb8e743fcfc8be.svg";
export { ForwardRef as ReactComponent };